import React, {useCallback, useEffect} from 'react'
import {useLocation, useParams} from 'react-router-dom';
import axios from "axios";
import ENV from "../ENV.json"

const ExternalpartnerMap = (props) => {

    //Lettura dei parametri
    let { id, jwt } = useParams();

    //Fetch dei dati del poi
    const loadPoi = useCallback(async () => {
        const token = 'Bearer ' + jwt;
        const data = {ID_POI: parseInt(id)};
        const config = {headers: { Authorization: token }};
        const url = `${ENV[ENV.ENV_STATE].baseUrl}/partner/get/poi`;
        console.log("Contattato: "+url);
        console.log(data);

        try {
            const response = await axios.post(url, data, config);
            console.log(response?.data);
        } catch (error) {
            console.error(error); // gestione dell'errore
        }

    },[id,jwt]);

    useEffect(()=>{
        loadPoi();
    },[id]);

    return (
        <div>
            <h1>ExternalpartnerMap</h1>
            <h2>Partner desidera il poi con id {id}</h2>
            <h2>Tentativo di accesso con {jwt}</h2>
        </div>
    )
}

export default ExternalpartnerMap;
